import EditUserConnector from './containers/EditUserConnector';

export default EditUserConnector;
